import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'
import camelcaseKeys from 'camelcase-keys'
import ApiClient from '@src/lib/api_client'

import Checkup from '@src/data/checkup'
import { Loader } from '@src/components/loading-screen/loader/loader'
import { API } from '@src/lib/api_path'
import { track } from '@src/util/functions'
import { TextCell } from '@src/components/table-list/cells'
import { ErrorScreen } from '@src/components/error-screen/error-screen'
import { StatusCell } from '@src/routes/members/components/checkups/status-cell'
import { CheckupsFilter } from '@src/routes/members/components/checkups/filter'
import { CheckupsList } from '@src/routes/members/components/checkups/list'
import { CheckupOptionsCell } from '@src/routes/member-platform/components/checkups/options-cell'
import { CheckupsDeviceFilter } from '@src/routes/members/components/checkups/device-filter'

type CheckupsResponse = { checkups: Checkup[] }

@Component
export class ReadonlyCheckups extends Vue {

  private checkups: Checkup[] = []

  private apiClient: ApiClient = new ApiClient()
  private loading: boolean = true

  constructor () {
    super()
    this.apiClient = new ApiClient()
    track('/members/checkups')
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.CHECKUPS')}`
  }

  render (h: CreateElement) {
    if (this.loading) {
      return <Loader />
    }

    if (this.checkups.length === 0) {
      return <ErrorScreen message={this.$t('PAGE.MEMBERS.CHECKUPS.EMPTY_LIST')} />
    }

    return <div id='readonly-checkups' class='scroll-content'>
      <div class='row'>
        <CheckupsFilter />
        <CheckupsDeviceFilter />
      </div>

      <CheckupsList checkups={this.checkups} cells={{
        date: TextCell,
        status: StatusCell,
        options: CheckupOptionsCell
      }} />
    </div>
  }

  created () {
    return this.loadCheckups()
  }

  private loadCheckups () {
    return this.apiClient.get<CheckupsResponse>(API.MEMBERS_API.CHECKUPS)
      .then((response: CheckupsResponse) => {
        this.checkups = response.checkups.map((checkup) => new Checkup(camelcaseKeys(checkup))).sort((a, b) => {
          const firstElementDate: Date = a.completedDate ? new Date(a.completedDate) : new Date(a.plannedDate)
          const secondElementDate: Date = b.completedDate ? new Date(b.completedDate) : new Date(b.plannedDate)
          if (firstElementDate.getTime() < secondElementDate.getTime()) return 1
          if (firstElementDate.getTime() > secondElementDate.getTime()) return -1
          return 0
        })
      })
      .catch(error => console.error('failed to retrieve checkup list', error))
      .finally(() => this.loading = false)
  }
}
